import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useAnnotationDelete = () => {
  const createPostRequest = (id) => {
    const requestUrl = `${API_BASE_URL}/api/v2/annotation/${id}/`;
    return new Request(requestUrl, {
      method: "DELETE",
      body: JSON.stringify({}),
      headers: { "Content-Type": "application/json" },
    });
  };

  return useRestMutation(createPostRequest);
};
export default useAnnotationDelete;
